
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/devops-development-services",
      function () {
        return require("private-next-pages/devops-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/devops-development-services"])
      });
    }
  